export enum SupportedPaymentMethod {
    ApplePay = 'ApplePay',
    GooglePay = 'GooglePay',
    Ideal = 'Ideal',
    PayPal = 'PayPal',
    PaymentCard = 'PaymentCard',
    SepaDirectDebit = 'SepaDirectDebit',
}
